import React, { useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import ContactModal from "./ContactModal";
import { HashLink } from "react-router-hash-link";


export default function ServicePage({
  titleKey,
  descriptionKey,
  image,
  accent = "blue",
}) {
  const { t } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-blue-900 via-gray-50 to-white py-24 sm:py-32">
      {/* Subtle grid */}
      <div
        aria-hidden
        className="absolute inset-0 bg-[linear-gradient(to_right,#bfdbfe_1px,transparent_1px),linear-gradient(to_bottom,#bfdbfe_1px,transparent_1px)]
        bg-[size:48px_48px] opacity-[0.3]
        [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_75%)]"
      />

      {/* Ambient glow */}
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[42rem] h-[42rem] bg-blue-200/30 blur-3xl rounded-full" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          >
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-8 mt-12">
              {t(titleKey)}
            </h1>

            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                {t(descriptionKey)}
              </p>
            </div>

            <div className="mt-12 flex flex-wrap gap-4">
              <button
                onClick={() => setIsContactModalOpen(true)}
                className="inline-flex items-center justify-center px-10 py-3.5 rounded-full
                           bg-blue-700 text-white text-sm font-semibold
                           shadow-none hover:shadow-sm hover:shadow-blue-700/40
                           transition-all"
              >
                {t('hero.cta_quote')}
              </button>

              <HashLink
                to="/#services"
                smooth
                className="inline-flex items-center justify-center px-10 py-3.5 rounded-full
                           border border-gray-300 text-sm font-semibold text-gray-700
                           hover:bg-gray-100 transition"
              >
                {t('common.view_all')}
              </HashLink>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="relative"
          >
            <div className="absolute -inset-6  blur-2xl rounded-3xl" />

            <div className="relative overflow-hidden rounded-3xl shadow-none bg-transparent">
              <img
                src={image}
                alt={t(titleKey)}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0" />
            </div>
          </motion.div>
        </div>
      </div>

      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
    </section>
  );
}
